export const SET_USER_AUTH = "user/SET_USER_AUTH";
export const SET_STORE_AUTH = "login/SET_STORE_AUTH";